export default {
	1: {
		"name" : "Like",
		"src"  : "https://images.rooter.gg/rooter-content-new/incoming/Like.png"
	},
	3: {
		"name" : "Wow",
		"src"  : "https://images.rooter.gg/rooter-content-new/incoming/Wow.png"
	},
	4: {
		"name" : "OP",
		"src"  : "https://images.rooter.gg/rooter-content-new/incoming/OP.png"
	},
	5: {
		"name" : "GoodGame",
		"src"  : "https://images.rooter.gg/rooter-content-new/incoming/GoodGame.png"
	},
	6: {
		"name" : "Noob",
		"src"  : "https://images.rooter.gg/rooter-content-new/incoming/Noob.png"
	},
	7: {
		"name" : "RIP",
		"src"  : "https://images.rooter.gg/rooter-content-new/incoming/RIP.png"
	},
	8: {
		"name" : "AngryFace",
		"src"  : "https://images.rooter.gg/rooter-content-new/incoming/AngryFace.png"
	}
};
